import dynamicfunction from '../utils/dynamicfunction';
import { useSelector } from 'react-redux';
import { textSizes } from '../config/config';
import { cn } from '../utils/utils';

const Text = ({
  text = '',
  weight,
  size,
  color = 'text-dark-grey',
  className,
  isRequired,
  isColon = false,
  onClick,
  isCenter,
  style,
  isDisabled,
  isTruncate = true,
  align,
  dir,
  children,
}) => {
  const { TextWeight, TextAlign, isArabic } = dynamicfunction();
  const fontsize = useSelector((state) => state.content?.fontsize);

  const getSize = () => {
    if (fontsize === textSizes.small) {
      return size ? Number(size) - 2 : 10;
    } else if (fontsize === textSizes.medium) {
      return size ? Number(size) : 12;
    } else if (fontsize === textSizes.large) {
      return size ? Number(size) + 2 : 14;
    }
  };

  return (
    <p
      style={{
        fontSize: getSize(),
        ...style,
      }}
      className={cn(
        isDisabled ? 'text-dark-grey/60' : color,
        weight ? weight : TextWeight.medium,
        isTruncate ? 'truncate' : '',
        isCenter ? 'text-center' : align ? align : TextAlign,
        className,
      )}
      onClick={isDisabled ? null : onClick}
      dir={dir ? dir : isArabic ? 'rtl' : 'ltr'}
    >
      {isColon ? `${text}:` : text}
      {children && children}
      {isRequired && <span className='text-red-500'>*</span>}
    </p>
  );
};

export default Text;
